<template>
    <div class="mobile-course-detail">
        <HeaderMobile />
        
        <!-- 视频播放器 -->
        <div class="video-player" v-if="courseType === 'video' && classList.length > 0">
            <video ref="videoPlayer" :src="currentVideo.urls ? resourceUrl + currentVideo.urls : ''" :poster="courseInfo.cover ? resourceUrl + courseInfo.cover : ''" @timeupdate="handleTimeUpdate" @loadedmetadata="handleLoadedMetadata" @pause="videoPaused = true" @play="videoPaused = false"></video>
            <div class="video-controls">
                <button class="control-btn" @click="toggleVideoPlay"><i :class="videoPaused ? 'el-icon-video-play' : 'el-icon-video-pause'"></i></button>
                <div class="progress-wrap">
                    <div class="progress-bar" @click="handleProgressClick">
                        <div class="progress-current" :style="{ width: currentPercent + '%' }"></div>
                    </div>
                    <span class="time-text">{{ formatTime(currentTime) }} / {{ formatTime(totalTime) }}</span>
                </div>
                <button class="control-btn" @click="toggleFullscreen"><i class="el-icon-full-screen"></i></button>
            </div>
            <div class="watch-limit-mask" v-if="watchLimitReached">
                <div class="limit-card">
                    <i class="el-icon-warning"></i>
                    <h3>试看时间已结束</h3>
                    <p>购买课程后即可观看完整内容</p>
                    <el-button type="primary" size="small" @click="goVipPage">立即购买</el-button>
                </div>
            </div>
        </div>

        <!-- 课程信息 -->
        <div class="course-info-section">
            <h1 class="course-title">{{ courseInfo.name }}</h1>
            <div class="course-meta">
                <span><i class="el-icon-user"></i>{{ author.name }}</span>
                <span><i class="el-icon-view"></i>{{ courseInfo.looks || 0 }}人</span>
                <span v-if="courseInfo.is_free != 1"><i class="el-icon-money"></i>¥{{ courseInfo.price }}</span>
            </div>
            <div class="course-actions">
                <el-button @click="toggleCollect" :type="courseInfo.is_collect ? 'warning' : 'default'" size="small"><i :class="courseInfo.is_collect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>{{ courseInfo.is_collect ? '已收藏' : '收藏' }}</el-button>
                <el-button type="primary" size="small" @click="goVipPage" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy">购买课程</el-button>
            </div>
        </div>

        <!-- Tab切换 -->
        <el-tabs v-model="activeTab" class="course-tabs">
            <el-tab-pane label="介绍" name="intro">
                <div class="intro-content">
                    <p v-html="courseInfo.describe || '暂无课程简介'"></p>
                </div>
            </el-tab-pane>
            <el-tab-pane label="章节" name="chapter">
                <div class="chapter-list">
                    <div class="chapter-item" v-for="(item, index) in classList" :key="item.id" :class="{ active: currentVideo.id === item.id }" @click="switchVideo(item)">
                        <span class="chapter-index">{{ index + 1 }}</span>
                        <span class="chapter-name">{{ item.name }}</span>
                        <span class="chapter-duration">{{ item.duration }}</span>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <FooterMobile />
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getCourse, dolCollect } from '@/api/home';
import { Session } from '@/utils/storage';

export default {
    name: 'MobileCourseInfo',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            courseType: 'video',
            resourceUrl: process.env.VUE_APP_STATIC_URL,
            isVip: false,
            courseInfo: {},
            author: {},
            classList: [],
            currentVideo: {},
            videoPaused: true,
            currentTime: 0,
            totalTime: 0,
            currentPercent: 0,
            watchLimitReached: false,
            activeTab: 'intro'
        };
    },
    created() {
        this.fetchCourseDetail();
    },
    methods: {
        fetchCourseDetail() {
            const courseId = this.$route.params.id;
            const chapterId = this.$route.query.chapter_id;
            getCourse(courseId).then(res => {
                if (res.code) {
                    this.courseInfo = res.data.course || {};
                    this.author = res.data.author || {};
                    this.classList = res.data.classes || [];
                    this.isVip = this.courseInfo.is_buy === 1 || this.courseInfo.is_free === 1;
                    this.courseType = this.courseInfo.ctype == 2 ? 'file' : 'video';
                    if (this.classList.length > 0) {
                        if (chapterId) {
                            const targetChapter = this.classList.find(item => item.id == chapterId);
                            this.currentVideo = targetChapter || this.classList[0];
                        } else {
                            this.currentVideo = this.classList[0];
                        }
                    }
                } else {
                    this.$message.error(res.msg || '获取课程详情失败');
                }
            }).catch(error => {
                console.error('获取课程详情失败：', error);
                this.$message.error('获取课程详情失败，请稍后重试');
            });
        },
        toggleVideoPlay() {
            const video = this.$refs.videoPlayer;
            if (!video) return;
            if (this.watchLimitReached) return this.$message.warning('试看时间已结束');
            if (video.paused) {
                video.play().catch(err => {
                    console.log('播放失败:', err);
                });
            } else {
                video.pause();
            }
        },
        toggleFullscreen() {
            const video = this.$refs.videoPlayer;
            if (!video) return;
            if (video.requestFullscreen) video.requestFullscreen();
        },
        handleTimeUpdate() {
            const video = this.$refs.videoPlayer;
            if (!video || !video.duration) return;
            this.currentTime = video.currentTime;
            this.totalTime = video.duration;
            this.currentPercent = Math.floor((this.currentTime / this.totalTime) * 100);
            if (!this.isVip && this.courseInfo.is_preview) {
                const previewSeconds = (this.courseInfo.preview_hours || 0) * 3600 + (this.courseInfo.preview_mins || 0) * 60 + (this.courseInfo.preview_seconds || 0);
                if (previewSeconds > 0 && this.currentTime >= previewSeconds) {
                    video.pause();
                    this.watchLimitReached = true;
                }
            }
        },
        handleLoadedMetadata() {
            const video = this.$refs.videoPlayer;
            if (video) this.totalTime = video.duration;
        },
        handleProgressClick(e) {
            const video = this.$refs.videoPlayer;
            if (!video || !video.duration || this.watchLimitReached) return;
            const progressBar = e.currentTarget;
            const clickX = e.offsetX;
            const percent = clickX / progressBar.offsetWidth;
            video.currentTime = percent * video.duration;
        },
        switchVideo(item) {
            this.currentVideo = item;
            this.watchLimitReached = false;
            this.videoPaused = true;
            this.currentTime = 0;
            this.$nextTick(() => {
                const video = this.$refs.videoPlayer;
                if (video) {
                    video.currentTime = 0;
                    video.load();
                }
            });
        },
        formatTime(seconds) {
            if (!seconds) return '00:00';
            const min = Math.floor(seconds / 60);
            const sec = Math.floor(seconds % 60);
            return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
        },
        toggleCollect() {
            if (!Session.get('token')) return this.$message.warning('请先登录');
            dolCollect({ id: this.$route.params.id }).then(res => {
                if (res.code) {
                    this.courseInfo.is_collect = !this.courseInfo.is_collect;
                    this.$message.success(this.courseInfo.is_collect ? '收藏成功' : '取消收藏成功');
                } else {
                    this.$message.error(res.msg || '操作失败');
                }
            }).catch(() => {
                this.$message.error('操作失败，请稍后重试');
            });
        },
        goVipPage() {
            if (!Session.get('token')) {
                this.$message.warning('请先登录');
                return;
            }
            this.$router.push('/mobile/pay?course_id=' + this.$route.params.id);
        }
    },
    watch: {
        '$route.params.id'(newId) {
            if (newId) {
                this.fetchCourseDetail();
            }
        }
    }
};
</script>

<style scoped>
.mobile-course-detail { min-height: 100vh; background: #f5f5f5; padding-top: 60px; user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; }
.video-player { position: relative; width: 100%; height: 220px; background: #000; }
.video-player video { width: 100%; height: 100%; object-fit: cover; }
.video-controls { position: absolute; bottom: 0; left: 0; right: 0; padding: 10px; background: linear-gradient(to top, rgba(0,0,0,0.8), transparent); display: flex; align-items: center; gap: 8px; }
.control-btn { width: 32px; height: 32px; background: rgba(255,255,255,0.2); border: none; border-radius: 4px; color: #fff; display: flex; align-items: center; justify-content: center; }
.progress-wrap { flex: 1; display: flex; flex-direction: column; gap: 4px; }
.progress-bar { height: 3px; background: rgba(255,255,255,0.3); border-radius: 2px; position: relative; }
.progress-current { position: absolute; top: 0; left: 0; height: 100%; background: #1890ff; border-radius: 2px; }
.time-text { font-size: 10px; color: #fff; }
.watch-limit-mask { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; }
.limit-card { background: #fff; border-radius: 8px; padding: 20px; text-align: center; max-width: 80%; }
.limit-card i { font-size: 48px; color: #f56c6c; margin-bottom: 12px; }
.limit-card h3 { font-size: 16px; margin-bottom: 8px; }
.limit-card p { font-size: 12px; color: #666; margin-bottom: 16px; }
.course-info-section { background: #fff; padding: 15px; margin-bottom: 10px; }
.course-title { font-size: 18px; font-weight: 600; margin-bottom: 10px; }
.course-meta { display: flex; gap: 15px; font-size: 12px; color: #666; margin-bottom: 10px; }
.course-meta i { margin-right: 4px; }
.course-actions { display: flex; gap: 10px; }
.course-tabs { background: #fff; padding: 0 15px; }
.intro-content, .chapter-list { padding: 15px; }
.chapter-item { display: flex; align-items: center; padding: 12px; background: #f8f8f8; border-radius: 8px; margin-bottom: 8px; }
.chapter-item.active { background: #e6f7ff; border-left: 3px solid #1890ff; }
.chapter-index { width: 24px; height: 24px; background: #1890ff; color: #fff; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; margin-right: 10px; }
.chapter-name { flex: 1; font-size: 14px; }
.chapter-duration { font-size: 12px; color: #999; }
</style>
